module.exports = __webpack_public_path__ + "static/media/quick-call.acd445d6.svg";